import SimpleLayout from 'features/shared/layout/SimpleLayout';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import React, { useEffect, useState } from 'react';
import ContractingMultiStepFormSection from './sections/ContractingMultiStepFormSection';
import ContractingStepConfiguration from './models/ContractingStepConfiguration';
import Header from 'features/shared/layout/header/Header';
import { loadModule } from 'features/shared/helpers/modules';
import UserManager from 'infrastructure/oidc/UserManager';
import { isLoginRequiredError } from 'infrastructure/oidc/oidcHelper';
import { getUrl, redirectToUrl } from 'features/shared/helpers/urlHelper';
import { trackPromise } from 'react-promise-tracker';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import { useTranslation } from 'react-i18next';

const contractingSteps = loadModule<ContractingStepConfiguration[]>(
  "contracting/contractingSteps.json"
);

const ContractingNew = () => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");

  // state
  const [isCheckUserState, setIsCheckUserState] = useState(false);

  // side-effects
  useEffect(() => {
    checkLoggedUser();
  }, []);
  
  // helpers
  const checkLoggedUser = async () => {  
    try {
      await trackPromise(UserManager.querySessionStatus());
      // logged user - redirect to contracting for logged user
      redirectToUrl(getUrl("contracting"));
    } catch (error) {
      // not logged user - continue to full contracting
      if (isLoginRequiredError(error)) {
        setIsCheckUserState(true);
      } else {
        throw error;
      }
    }
  }

  // render
  return (
    <SimpleLayout useSpinner fixedWidht>
      <RenderWrapper isVisible={() => isCheckUserState}>
        <Header
          title={t("contractingNew.title")}
        />
        <ModuleContent>
          <ContractingMultiStepFormSection 
            steps={contractingSteps}
            routePrefix="/contracting/new"
            enableSaveBtn
            enableBackToLoginBtn
          />
        </ModuleContent>
      </RenderWrapper>
    </SimpleLayout>
  )
}

export default ContractingNew;